import { Component, Input, OnInit } from "@angular/core";

/* tslint:disable */
@Component({
  selector: "app-group-info-expanded",
  templateUrl: "./group-info-expanded.component.html",
  styleUrls: ["./group-info-expanded.component.scss"],
  standalone: false,
})
export class GroupInfoExpandedComponent implements OnInit {
  groupAdminExpand = false;
  @Input() subgroupInfo: any;

  constructor() {}

  ngOnInit(): void {}
}
